import { z, type EnumValues } from 'zod';

type EnumType = readonly [string, ...string[]];
interface PossibleOptions {
  possibleQuestions: EnumType | [],
}

export const getIFStatementSchema = ({
  possibleQuestions,
}: PossibleOptions) => {
  return z.object({
    condStatements: z.array(z.object({
      op: z.union([z.literal('or'), z.literal('else')]),
      value: z.union([
        z.array(z.object({
          op: z.enum(['eq']),
          value: possibleQuestions.length ? z.enum(possibleQuestions as EnumValues) : z.string(),
        })).min(1, 'Condition is required'),
        z.null(),
      ])
    })),
    condSourceId: z.string().min(1, 'Field is required'),
  });
}
